import { withClassName } from '@/common/theme/withClassName';
import type { HTMLAttributes } from 'react';
import styles from './button-container.module.scss';

export const ButtonContainer = withClassName<HTMLAttributes<HTMLDivElement>>(
  'div',
  styles.container,
  'ButtonContainer',
);

export const RedesignButtonContainer = withClassName(
  ButtonContainer,
  styles.redesign,
  'RedesignButtonContainer',
);
